//Quoocker page js start
document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll(".quooker-block");

    blocks.forEach(block => {
      const hasSpout = block.querySelectorAll(".spout").length > 0;
      const hasMaterial = block.querySelectorAll(".material").length > 0;
      const spoutEls = block.querySelectorAll(".spout");
      const materialEls = block.querySelectorAll(".material");
      const proImage = block.querySelector(".pro_image");
      const linkEl = block.querySelector(".plink");
      const pimages = block.querySelectorAll(".anc-pro");

      let selectedSpout = hasSpout
        ? block.querySelector(".spout.selected span:last-child")?.textContent.trim() || "" : "";

      let selectedMaterial = hasMaterial
        ? block.querySelector(".material.selected span")?.textContent.trim() || "" : "";

      function updateProductImage() {
        let match = Array.from(pimages).find(el =>
          (!hasSpout || el.getAttribute("spout") === selectedSpout) &&
          (!hasMaterial || el.getAttribute("material") === selectedMaterial)
        );

        if (match) {
          proImage.src = match.getAttribute("img");
          linkEl.href = match.getAttribute("url");

          // Update display text to match spout if available
          const title = match.getAttribute("spout") || match.getAttribute("material") || "";
          linkEl.querySelector(".lt").textContent = title;
        }
      }

      spoutEls.forEach(el => {
        el.addEventListener("click", () => {
          spoutEls.forEach(e => e.classList.remove("selected"));
          el.classList.add("selected");
          selectedSpout = el.querySelector("span:last-child").textContent.trim();
          updateProductImage();
        });
      });

      materialEls.forEach(el => {
        el.addEventListener("click", () => {
          materialEls.forEach(e => e.classList.remove("selected"));
          el.classList.add("selected");
          selectedMaterial = el.querySelector("span").textContent.trim();
          updateProductImage();
        });
      });

      updateProductImage(); // run on page load
   });
   document.querySelectorAll('.pro_image').forEach(img => {
      img.style.opacity = '1';
   });
   initOrDestroySlick();
});

function initOrDestroySlick() {
  const isMobile = window.innerWidth < 768; 
  const $carousel = $('.quooker-top-badge'); 
    if (isMobile) {
      if (!$carousel.hasClass('slick-initialised')) {
        $carousel.slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          slidesToScroll: 1,
          arrows: false,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
         $carousel.slick('refresh');
      } else {
        $carousel.slick('unslick');
      }
    }else{
      $carousel.slick('unslick');
    }
}
$(window).on('resize', function () {
  initOrDestroySlick();
});  
//Quoocker page js end

$(document).ready(function () {
  // Remove space from contact form input field js start
  const forms = ['#contact_form', '#predictive-search-form'];

  forms.forEach(function (formId) {
    const $form = $(formId);

    // Trim leading space on input and paste
    $form.find('input, textarea').on('input paste', function () {
      const cleanedValue = $(this).val().replace(/^\s+/, '');
      $(this).val(cleanedValue);
    });

    // Final cleanup on submit: trim both leading and trailing spaces
    $form.on('submit', function () {
      $(this).find('input, textarea').each(function () {
        $(this).val($(this).val().trim());
      });
    });
  });
  // Remove space from contact form input field js end

  // when clicking review star in pdp page scroll to review tab js start
  $(document).on('click', '.feefo-review-badge-wrapper-product', function (e) {
    e.preventDefault();
    const isMobile = window.innerWidth <= 768;
    const $descTab = $('.tab-description');
    const $reviewTabDesktop = $('.customer-reviews--js').not('.hidden-lap-and-up');
    const $reviewTabMobile = $('.customer-reviews--js.hidden-lap-and-up');
    const $reviewTab = isMobile ? $reviewTabMobile : $reviewTabDesktop;
    const descOpen = $descTab.attr('aria-expanded') === 'true';
    const reviewOpen = $reviewTab.attr('aria-expanded') === 'true';
    const scrollToTab = () => {
      const offset = $reviewTab.offset().top - 100;
      $('html, body').animate({
        scrollTop: offset
      }, 600);
    };
  
    if (isMobile) {
      // MOBILE: Manually collapse description tab to prevent reopen
      if (descOpen) {
        $descTab.attr('aria-expanded', 'false');
        const descContentId = $descTab.attr('aria-controls');
        $('#' + descContentId).slideUp();
      }
  
      if (!reviewOpen) {
        $reviewTab.trigger('click');
        setTimeout(scrollToTab, 400);
      } else {
        scrollToTab();
      }
  
    } else {
      // DESKTOP: Use normal tab switching
      if (descOpen) {
        $descTab.trigger('click'); // just trigger close
      }
  
      if (!reviewOpen) {
        $reviewTab.trigger('click');
        setTimeout(scrollToTab, 200);
      } else {
        scrollToTab();
      }
    }
  });
  // when clicking review star in pdp page scroll to review tab js end

  // start js for product image zoom in out popup
  $(document).on('click', '.shopify-section--main-product .product__zoom-button', function (e) {
    $('body').addClass('custom-zoom-out-in-for-products');
  });
  $(document).on('click', '.shopify-section--main-product .pswp__button--close', function (e) {
    $('body').removeClass('custom-zoom-out-in-for-products');
  });
  // end js for product image zoom in out popup

  //cart drawer timer js start
  var totalTime = 4 * 60;
  var timerInterval = setInterval(function() {
    var minutes = Math.floor(totalTime / 60);
    var seconds = totalTime % 60;
    $('.minicart__timer .minutes').text(minutes < 10 ? '0' + minutes : minutes);
    $('.minicart__timer .seconds').text(seconds < 10 ? '0' + seconds : seconds);
    totalTime--;
    if (totalTime < 0) {
      clearInterval(timerInterval);
      $('.minicart__timer').html('<span>Your cart expiring soon</span>');
    }
  }, 1000);
  //cart drawer timer js end
  
  // Collection page app filter collpased on page load js start
  jQuery(function($) {
    var retryCount = 0;
    var maxRetries = 10;
    var delay = 300;

    function addClassToFacets() {
      var $facets = $('.usf-facet');
      if ($facets.length > 0) {
        $facets.each(function() {
          var $facet = $(this);
          if (!$facet.hasClass('usf-collapsed')) {
            $facet.addClass('usf-collapsed');
          }
        });
      } else if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(addClassToFacets, delay);
      }
    }

    setTimeout(addClassToFacets, 1000); // Initial delay
  });
  // Collection page app filter collpased on page load js end

  // Redirect urls to home page which contains word "referer" js start
  if (window.location.href.includes("referer")) {
    window.location.href = "/";
  }
  // Redirect urls to home page which contains word "referer" js end
});